import { render, staticRenderFns } from "./FeaturesHeader.vue?vue&type=template&id=dec92de4"
import script from "./FeaturesHeader.vue?vue&type=script&lang=js"
export * from "./FeaturesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports